import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-background">
      <div className="w-full max-w-md border border-border bg-card p-8 rounded-sm text-center">
        <XCircle className="w-14 h-14 text-yellow-500 mx-auto mb-4"/>
        <h2 className="font-display font-black text-3xl uppercase mb-2">Payment cancelled</h2>
        <div className="text-sm text-muted-foreground mb-6">No amount was charged. You can retry any time.</div>
        <Link to="/invoices"><Button className="rounded-sm bg-primary text-primary-foreground uppercase tracking-[0.15em]">Back to Invoices</Button></Link>
      </div>
    </div>
  );
}
